import { FormGroup, FormArray } from "@angular/forms";
import { TranslationModel } from "../core/models/translation.model";
import { Injectable } from "@angular/core";
import { ToastService } from "../core/toast.service";
import { TranslateService } from "@ngx-translate/core";
import { environment } from "../../environments/environment";
import * as moment from "moment";
import { HttpClient } from "@angular/common/http";

@Injectable()
export class Helpers {
  constructor(
    private toastService: ToastService,
    private translateService: TranslateService,
    private httpClient: HttpClient
  ) { }

  public static markFormGroupTouched(formGroup: FormGroup) {
    (Object as any).values(formGroup.controls).forEach((control) => {
      control.markAsTouched();

      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  public static markFormGroupDirty(formGroup: FormGroup) {
    (Object as any).values(formGroup.controls).forEach((control: FormGroup) => {
      control.markAsDirty();

      if (control.controls) {
        this.markFormGroupDirty(control);
      }
    });
  }

  public static markFormGroupPristine(formGroup: FormGroup) {
    (Object as any).values(formGroup.controls).forEach((control: FormGroup) => {
      control.markAsPristine();

      if (control.controls) {
        this.markFormGroupPristine(control);
      }
    });
  }

  public static searchDataArray(
    searchStr: string,
    arr: Array<any>
  ): Array<any> {
    const filtered = arr.filter((x) => {
      for (let prop in x) {
        if (
          x[prop] &&
          x[prop].toLowerCase().indexOf(searchStr.toLowerCase()) > -1
        )
          return true;
      }
      return false;
    });

    return filtered;
  }

  public static markFormGroupUntouched(formGroup: FormGroup) {
    (Object as any).values(formGroup.controls).forEach((control: FormGroup) => {
      control.markAsUntouched();

      if (control.controls) {
        this.markFormGroupUntouched(control);
      }
    });
  }

  public static jsonToFormEncoded(data: any) {
    const str = [];
    for (let key in data) {
      if (data.hasOwnProperty(key)) {
        str.push(encodeURIComponent(key) + "=" + encodeURIComponent(data[key]));
      }
    }
    return str.join("&");
  }

  public static getQueryStringParameter(paramName: string) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.has(paramName) ? urlParams.get(paramName) : undefined;
  }

  /**
   * @deprecated use getCurrentOrDefaultTranslation.
   */
  public static getCurrentTranslation(data: Array<TranslationModel>) {
    if (!data) return undefined;

    if (data.length === 0) return undefined;

    return data[0];
  }

  public static stripHtmlTags(str: string) {
    return str.replace(/<[^>]*>/g, "");
  }

  public static cutString(
    str: string,
    length: number,
    addDots: boolean = false
  ) {
    const dots = str.length > length ? ".." : "";

    str = str.length > length ? str.substring(0, length - 1) : str;

    if (addDots) {
      str += dots;
    }

    return str;
  }

  public static capitalizeFirstLetter(str: string) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  fixCommunityImages(community: any) {
    if (!community.communityCover) {
      community.communityCover = "/assets/images/genericCover.png";
    } else {
      if (community.communityCover.indexOf("http") === -1) {
        community.communityCover =
          environment.serverPath + community.communityCover;
      }
    }

    if (!community.communityImage) {
      community.communityImage = "/assets/images/community.png";
    } else {
      if (community.communityImage.indexOf("http") === -1) {
        community.communityImage =
          environment.serverPath + community.communityImage;
      }
    }
  }

  fixCommunityCoverImages(community: any) {
    if (!community.communityCover) {
      community.communityCover = "/assets/images/genericCover.png";
    } else {
      if (community.communityCover.indexOf("http") === -1) {
        community.communityCover =
          environment.serverPath + community.communityCover;
      }
    }
  }

  fixEventImages(event: any) {
    if (!event.eventCover) {
        event.eventCover = "/assets/images/genericCover.png";
    } else {
      if (event.eventCover.indexOf("http") === -1) {
        event.eventCover =
          environment.serverPath + event.eventCover;
      }
    }

    if (!event.eventImage) {
        event.eventImage = "/assets/images/community.png";
    } else {
      if (event.eventImage.indexOf("http") === -1) {
        event.eventImage =
          environment.serverPath + event.eventImage;
      }
    }
  }

  fixEventCoverImages(event: any) {
    if (!event.eventCover) {
        event.eventCover = "/assets/images/genericCover.png";
    } else {
      if (event.eventCover.indexOf("http") === -1) {
        event.eventCover =
          environment.serverPath + event.eventCover;
      }
    }
  }

  isInViewport(element: HTMLElement) {
    const rect = element.getBoundingClientRect();
    return rect.top <= window.innerHeight + 400;
  }

  uploadImage(files: any) {
    const formData = new FormData();
    if(Array.isArray(files)){
    files.forEach((file: any) => {
    formData.append("images", file);
  });}else{
    formData.append("images", files);
  }
    return this.httpClient.post(
      `${environment.serverPath}/general/upload-image`,
      formData
    );
  }

  public randomStringLowCase(length: number = 10) {
    let result = "";
    const characters = "abcdefghijklmnopqrstuvwxyz";
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}

  public stringifyDate(date: Date) {
    if (!date) return "";

    if (moment(date).isValid()) {
      return moment(date).format(environment.dateDefaultFormat);
    }

    return "";
  }

  public getCurrentOrDefaultTranslation(data: Array<TranslationModel>) {
    if (!data) return "";

    let lang = this.translateService.currentLang;

    let translation = data.find((x) => x.locale === lang);

    if (!translation) {
      translation = data.find((x) => x.locale === environment.defaultLang);
    }

    if (!translation && data.length > 0) {
      translation = data[0];
    }

    return translation.value;
  }

  public responseHasErrors(response: any, showToast: boolean = false) {
    if (!response) return false;

    let hasErrors = false;

    if (response.status && response.status === 500) {
      hasErrors = true;
      if (showToast) {
        let message = this.translateService.instant(
          `alerts.${response.statusText}`
        );
        if (response.error && response.error.error) {
          if (
            response.error.error.exception.find(
              (d: any) =>
                d.class ===
                "Doctrine\\DBAL\\Exception\\ForeignKeyConstraintViolationException"
            )
          ) {
            const error = response.error.error.exception.find(
              (d: any) =>
                d.class ===
                "Doctrine\\DBAL\\Exception\\ForeignKeyConstraintViolationException"
            );

            if (error.message.indexOf("DELETE FROM")) {
              message = this.translateService.instant(
                "alerts.CannotDeleteIntegrityConstraint"
              );
            }
          }
        }
        this.toastService.errorMessage(message);
      }
    } else if (
      response.status &&
      response.status === 400 &&
      response.statusText === "VALIDATION_ERROR" &&
      response.message &&
      response.message instanceof Array
    ) {
      hasErrors = true;
      if (showToast) {
        if (response.message[0].message === "NO_CONSENT") {
          this.toastService.errorMessage(
            this.translateService.instant(
              `alerts.${response.message[0].message}`
            )
          );
        }
      }
    }

    return hasErrors;
  }

  isValid(name: string, form: FormGroup): boolean {
    let control = null;
    if (form) {
      control = form.get(name);
    }
    if (control) {
      return control.valid || !control.touched;
    } else {
      return true;
    }
  }

  hasException(response) {
    if (response && response.exception) {
      // alert(this.translateService.instant(`alerts.${response.exception}`), this.translateService.instant("alerts.errorTitle"));
      return true;
    }

    if (response && response.error) {
      // alert(this.translateService.instant(`alerts.GENERAL_ERROR`), this.translateService.instant("alerts.errorTitle"));
      return true;
    }
    return false;
  }

  removeGreekAccents(str: string) {
    const text = str
      .replace(/Ά|Α|ά/g, "α")
      .replace(/Έ|Ε|έ/g, "ε")
      .replace(/Ή|Η|ή/g, "η")
      .replace(/Ί|Ϊ|Ι|ί|ΐ|ϊ/g, "ι")
      .replace(/Ό|Ο|ό/g, "ο")
      .replace(/Ύ|Ϋ|Υ|ύ|ΰ|ϋ/g, "υ")
      .replace(/Ώ|Ω|ώ/g, "ω")
      .replace(/Σ|ς/g, "σ");
    return text;
  }

  public findInvalidControlsRecursive(
    formToInvestigate: FormGroup | FormArray
  ): string[] {
    let invalidControls: string[] = [];
    let recursiveFunc = (form: FormGroup | FormArray) => {
      Object.keys(form.controls).forEach((field) => {
        const control = form.get(field);
        if (control.invalid) invalidControls.push(field);
        if (control instanceof FormGroup) {
          recursiveFunc(control);
        } else if (control instanceof FormArray) {
          recursiveFunc(control);
        }
      });
    };
    recursiveFunc(formToInvestigate);
    return invalidControls;
  }

  getLocale() {
    let locale = this.translateService.currentLang;
    if (locale === "gr") {
      locale = "el";
    }

    return locale;
  }

  fixProfileImages(profile: any) {
    if (!profile.profileCover) {
      profile.profileCover = "/assets/images/genericCover.jpg";
    } else {
      if (profile.profileCover.indexOf("http") === -1) {
        profile.profileCover = environment.serverPath + profile.profileCover;
      }
    }

    if (!profile.profileImage) {
      profile.profileImage = "/assets/images/profile.jpg";
    } else {
      if (profile.profileImage.indexOf("http") === -1) {
        profile.profileImage = environment.serverPath + profile.profileImage;
      }
    }
  }

  getPostedOn(datetime: string) {
    const momentTIme = moment(datetime);
    const diffInSeconds = moment().diff(momentTIme, "seconds");
    let str = "";

    if (diffInSeconds < 60) {
      str = this.translateService.instant("timelineHourBeforeSeconds", {
        time: diffInSeconds,
      });
    } else if (diffInSeconds >= 60 && diffInSeconds < 3600) {
      str = this.translateService.instant("timelineHourBeforeMinuts", {
        time: Math.floor(moment().diff(momentTIme, "minutes")),
      });
    } else if (diffInSeconds >= 3600 && diffInSeconds < 86400) {
      str = this.translateService.instant("timelineHourBeforeHours", {
        time: Math.floor(moment().diff(momentTIme, "hours")),
      });
    } else if (diffInSeconds >= 86400 && diffInSeconds < 86400 * 10) {
      str = this.translateService.instant("timelineHourBeforeDays", {
        time: Math.floor(moment().diff(momentTIme, "days")),
      });
    } else {
      str = momentTIme.format("DD/MM/YYYY");
    }
    return str;
  }
}
